var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCatalogNothumbnail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.419,
    height: 75.951,
    viewBox: "0 0 105.419 75.951",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#cce1ff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#b4cfef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#bed6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#c8defc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cce1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-493 -150)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M598.419,210.44H493V157.628A7.629,7.629,0,0,1,500.628,150h23.65a7.627,7.627,0,0,1,6.255,3.261l2.1,3.014a1.762,1.762,0,0,0,1.445.753h57.45a6.885,6.885,0,0,1,6.886,6.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H105a0,0,0,0,1,0,0V53.015A4.985,4.985,0,0,1,100.015,58H4.985A4.985,4.985,0,0,1,0,53.015V0A0,0,0,0,1,0,0Z",
    transform: "translate(493.209 167.951)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCatalogNothumbnail);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTA1LjQxOSIgaGVpZ2h0PSI3NS45NTEiIHZpZXdCb3g9IjAgMCAxMDUuNDE5IDc1Ljk1MSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6dXJsKCNhKTt9LmJ7ZmlsbDojY2NlMWZmO308L3N0eWxlPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjAuNSIgeTE9IjEiIHgyPSIwLjUiIGdyYWRpZW50VW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij48c3RvcCBvZmZzZXQ9IjAuNzA5IiBzdG9wLWNvbG9yPSIjYjRjZmVmIi8+PHN0b3Agb2Zmc2V0PSIwLjc3MSIgc3RvcC1jb2xvcj0iI2JlZDZmNSIvPjxzdG9wIG9mZnNldD0iMC44NzciIHN0b3AtY29sb3I9IiNjOGRlZmMiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNjY2UxZmYiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDkzIC0xNTApIj48cGF0aCBjbGFzcz0iYSIgZD0iTTU5OC40MTksMjEwLjQ0SDQ5M1YxNTcuNjI4QTcuNjI5LDcuNjI5LDAsMCwxLDUwMC42MjgsMTUwaDIzLjY1YTcuNjI3LDcuNjI3LDAsMCwxLDYuMjU1LDMuMjYxbDIuMSwzLjAxNGExLjc2MiwxLjc2MiwwLDAsMCwxLjQ0NS43NTNoNTcuNDVhNi44ODUsNi44ODUsMCwwLDEsNi44ODYsNi44ODZaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0wLDBIMTA1YTAsMCwwLDAsMSwwLDBWNTMuMDE1QTQuOTg1LDQuOTg1LDAsMCwxLDEwMC4wMTUsNThINC45ODVBNC45ODUsNC45ODUsMCwwLDEsMCw1My4wMTVWMEEwLDAsMCwwLDEsMCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDkzLjIwOSAxNjcuOTUxKSIvPjwvZz48L3N2Zz4=";